module.exports = __webpack_public_path__ + "static/media/skillsg.f4b7c823.webp";